// Invoice.js
import React, { useEffect } from 'react';
import PopupModal from './PopupModal.js';
import ProcessedHtml from './snippet/ProcessedHtml.js';

const Invoice = ({ activeTheme, clientName, language, font, selectedLayout, carbon, rating, brandColor, seasonBrand,ProductCount, onGrandTotal}) => {
  window.prevNumbers = window.prevNumbers || {}; 
  useEffect(() => {
    if (clientName==='hm') {document.title = `Invoice | H&M`;}
    if (clientName==='lego') {document.title = `Invoice | LEGO`;}
    if (clientName==='warhammer') {document.title = `Invoice | Warhammer`;}
    else if (clientName) {
      const sentenceCaseName =clientName.charAt(0).toUpperCase() + clientName.slice(1).toLowerCase();
      document.title = `Invoice | ${sentenceCaseName}`;
    } else {document.title = "Invoice | Invotools";}
  }, [clientName]);
  useEffect(() => {
    if (['yellow', 'green', 'blue', 'red', 'maroon', 'gray', 'black','printer','lego','warhammer'].includes(activeTheme)) {
      document.body.classList.forEach(c => c.startsWith("theme-") && document.body.classList.remove(c));
      document.body.classList.add(`theme-${activeTheme}`);
      let colorLink = document.getElementById('theme-change');        
      if (!colorLink) {
        colorLink = document.createElement('link');
        colorLink.id = 'theme-change';
        colorLink.rel = 'stylesheet';
        document.head.appendChild(colorLink);
      }
      colorLink.href = `/scss/themes/${activeTheme}.min.css`;      
      const brandLink = document.getElementById('brand-season'); if(brandLink){brandLink.remove('');}
      const CommonLink = document.getElementById('brand-common'); if(CommonLink){CommonLink.remove('');}
    }

    if (['brand_blackfriday','brand_christmas', 'brand_newyear','brand_ads', 'brand_diwali', 'brand_thanks'].includes(activeTheme)) {     
      let CommonLink = document.getElementById('brand-common');            
      if (!CommonLink) {
        CommonLink = document.createElement('link');
        CommonLink.id = 'brand-common';
        CommonLink.rel = 'stylesheet';
        document.head.appendChild(CommonLink);
        CommonLink.href = `/scss/themes/brand_common.min.css`;       
      }    
      let brandLink = document.getElementById('brand-season'); 
      if (!brandLink) {
        brandLink = document.createElement('link');
        brandLink.id = 'brand-season';
        brandLink.rel = 'stylesheet';
        document.head.appendChild(brandLink);
      }
      brandLink.href = `/scss/themes/${activeTheme}.min.css`;

    let finalBrandColor = brandColor;
    if (!finalBrandColor || finalBrandColor === 0) {
      if (activeTheme === "brand_christmas") finalBrandColor = 'blue';
      if (activeTheme === "brand_newyear") finalBrandColor = 'black';
      if (activeTheme === "brand_blackfriday") finalBrandColor = 'black';      
      if (activeTheme === "brand_diwali") finalBrandColor = 'maroon';
      if (activeTheme === "brand_thanks") finalBrandColor = 'yellow';
      if (activeTheme === "brand_ads") finalBrandColor = 'gray';
    }

    if(seasonBrand){
      if (seasonBrand.includes("brand_christmas") && activeTheme === "brand_christmas") finalBrandColor = 'blue';
      if (seasonBrand.includes("brand_newyear") && activeTheme === "brand_newyear") finalBrandColor = 'black';
      if (seasonBrand.includes("brand_blackfriday") && activeTheme === "brand_blackfriday") finalBrandColor = 'black';      
      if (seasonBrand.includes("brand_diwali") && activeTheme === "brand_diwali") finalBrandColor = 'maroon';
      if (seasonBrand.includes("brand_thanks") && activeTheme === "brand_thanks") finalBrandColor = 'yellow';
      if (seasonBrand.includes("brand_ads") && activeTheme === "brand_ads") finalBrandColor = 'gray';
    }

      let colorLink = document.getElementById('theme-change');
      if(!colorLink) {
        colorLink = document.createElement('link');
        colorLink.id = 'theme-change';
        colorLink.rel = 'stylesheet';
        document.head.appendChild(colorLink);
      }
      colorLink.href = `/scss/themes/${finalBrandColor}.min.css`;
      document.body.classList.forEach(c => c.startsWith("theme-") && document.body.classList.remove(c));    
      document.body.classList.add(`theme-${finalBrandColor}`);
      document.body.classList.add(`theme-${activeTheme}`);
    }

    let fontLink = document.getElementById('font-change');    
    if (!fontLink) {
      fontLink = document.createElement('link');
      fontLink.id = 'font-change';
      fontLink.rel = 'stylesheet';
      document.head.appendChild(fontLink);
    }
    fontLink.href = `/root-css/fonts/font-${font}.css`;

    if (selectedLayout === 'layout-featured') {
      let LayoutCSS = document.getElementById('layout-change');
      if (LayoutCSS) LayoutCSS.remove();
    } else {
      let LayoutCSS = document.getElementById('layout-change');    
      if (!LayoutCSS) {
        LayoutCSS = document.createElement('link');
        LayoutCSS.id = 'layout-change';
        LayoutCSS.rel = 'stylesheet';
        document.head.appendChild(LayoutCSS);
      }
      LayoutCSS.href = `/root-css/${selectedLayout}.css`;
    }

    if (['layout-bill', 'layout-small', 'layout-full', 'layout-simple','layout-pdf', 'layout-a4print','layout-a5print', 'layout-a6print'].includes(selectedLayout)) {
      if (['diwali', 'christmas', 'thanks'].includes(activeTheme)) {
        let LayoutCSS = document.getElementById('layout-change1');    
        if (!LayoutCSS) {
          LayoutCSS = document.createElement('link');
          LayoutCSS.id = 'layout-change1';
          LayoutCSS.rel = 'stylesheet';
          document.head.appendChild(LayoutCSS);
        }
        LayoutCSS.href = `/root-css/layout-festival-${selectedLayout}-fix.css`;
      }
    }

    if (clientName) {
      let ClientCSS = document.getElementById('client-css');
      if (!ClientCSS) {
        ClientCSS = document.createElement('link');
        ClientCSS.id = 'client-css';
        ClientCSS.rel = 'stylesheet';
        document.head.appendChild(ClientCSS);
      }
      ClientCSS.href = `/invoice/client/${clientName}/assets/extra-css/extra.css`;
      const link = document.querySelector("link[rel='icon']");
      link.href = `/invoice/client/${clientName}/assets/images/favicon.png`;
    }
  }, [activeTheme, font, selectedLayout, clientName]);

  if (!document.getElementById('theme-fadein')) {
    const fadeinLink = document.createElement('link');
    fadeinLink.id = 'theme-fadein';
    fadeinLink.rel = 'stylesheet';
    fadeinLink.href = '/root-css/a_fadein.css';
    document.head.appendChild(fadeinLink);
  }

  useEffect(() => { 
 document.body.classList.add('pt-lg-2');

    if (activeTheme === 'printer') {
      document.body.classList.remove('dark-mode');
    }

    document.documentElement.dir = language === 'arabic' ? 'rtl' : '';

    if (font) {      
      const fontClasses = ['font-fira', 'font-nunito', 'font-open', 'font-lato', 'font-poppins', 'font-montserrat', 'font-raleway', 'font-ubuntu', 'font-playfair', 'font-merriweather', 'font-source'];
      fontClasses.forEach(fontClass => document.body.classList.remove(fontClass));
      document.body.classList.add(font);
    }   
  }, [activeTheme, language, font]); 

  return (
    <> 
    
      <ProcessedHtml clientName={clientName} language={language} ProductCount={ProductCount} onGrandTotal={onGrandTotal}/>
      <PopupModal language={language}/>
      {carbon === 0 && (<style>{`.carbon{display:none!important;}`}</style>)}
      {rating === 0 && (<style>{`.rating-btn{display:none!important;}`}</style>)}
    </>
  );
};

export default Invoice;
